import styled from 'styled-components';
import Card from '@material-ui/core/Card';

export interface OutlinedCardWrapperProps {
    centered?: string;
    grouped?: string;
    $handheld?: string;
    $textColor?: string;
    $cardBackgroundColor?: string;
    $hoverCardBackgroundColor?: string;
    $cardNoBorder?: boolean;
    $hoverArrowColor?: string;
    $hoverTextColor?: string;
    $isTwinmotion?: boolean;
}

const getRadialGradient = (from, to) =>
    `radial-gradient(100% 185.14% at 100% 100%, ${from} 0%, ${to} 100%)`;

export const OutlinedCardWrapper = styled(Card)<OutlinedCardWrapperProps>`
    &&& {
        background-color: ${(p) =>
            p.$cardBackgroundColor ? p.$cardBackgroundColor : 'transparent'};
        border-radius: 0;
        box-shadow: none;

        ${(p) => (p.$cardNoBorder ? 'border: 0px' : '')};
    }
    && {
        --switch: calc((var(80) - var(60)) * -100%);
        color: ${(p) => (p.$textColor ? p.$textColor : 'hsl(0, 0%, var(--switch))')};
        transition: color 0.25s ${(p) => p.theme.easing};
        display: flex;
        flex-flow: column wrap;
        text-align: ${(p) => (p.centered ? 'center' : 'left')};
        min-height: ${(p) => (p.$handheld ? 'auto' : `${p.theme.spacing(32.5)}px`)};
        height: ${(p) => (p.grouped ? '100%' : 'auto')};
        max-width: ${(p) => (p.$handheld ? '100%' : `${p.theme.spacing(38)}px}`)};
        border: ${(p) => p.theme.spacing(0.5)}px solid;
        padding: ${(p) => p.theme.spacing(3)}px;
        background: none;
        background-size: 100%;
        position: relative;
        z-index: 100;
        box-sizing: border-box;

        &.fill-parent .ue-link-wrap-span {
            height: 100%;
            width: 100%;
            .ue-link-wrap {
                min-width: initial;
                min-height: initial;
                max-width: initial;
                max-height: initial;
                height: 100%;
                width: 100%;
                display: flex;
                flex-flow: column wrap;
            }
        }
        .paragraph {
            color: ${(p) => (p.$textColor ? p.$textColor : 'hsl(0, 0%, var(--switch))')};
        }

        &:before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            height: 100%;
            width: 100%;
            z-index: -100;
            transition: opacity 0.25s ${(p) => p.theme.easing};
        }
        &&.clickable {
            cursor: pointer;
            &:hover {
                color: ${(p) => p.$hoverTextColor || 'black'};
                background-color: ${(p) =>
                    p.$hoverCardBackgroundColor ? p.$hoverCardBackgroundColor : 'transparent'};
                transition: color 0.25s ${(p) => p.theme.easing},
                    background-color 0.25s ${(p) => p.theme.easing};
                &:before {
                    transition: opacity 0.25s ${(p) => p.theme.easing};
                    opacity: 1;
                }
                .ue-icon-arrow-right-alt {
                    color: ${(p) => p.$hoverArrowColor};
                }
                .paragraph {
                    color: ${(p) => p.$hoverTextColor || 'black'};
                }
            }
        }
        ${(p) => {
            const colors: string[] = [];
            const {gradient} = p.theme.palette;
            if (!p.$hoverCardBackgroundColor) {
                for (const color in gradient) {
                    if (Object.prototype.hasOwnProperty.call(gradient, color)) {
                        colors.push(`
                            &.${color} {
                                border-image: ${getRadialGradient(
                                    gradient[color].from,
                                    gradient[color].to
                                )} 5;

                                border-image-width: 4px;

                                &:before {
                                    background-image: ${getRadialGradient(
                                        gradient[color].from,
                                        gradient[color].to
                                    )};
                                }

                            }
                        `);
                    }
                }
            }
            return colors.join('\n');
        }}
    }
    h3 {
        text-overflow: ellipsis;
        overflow: hidden;
    }
    h4 {
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .card-content {
        margin-top: auto;
        ${(p) => !p.$isTwinmotion && `align-self: flex-end;`}
    }

    ${(p) =>
        !p.$isTwinmotion &&
        `
            .ue-link-wrap-span{
                height: 100%;
            }
            .ue-outlined {
                display: inline-flex;
                flex-flow: column wrap;
                height: 100%;
            }
        `}
`;
